export enum Category {
  ScrubPants = 'Scrub Pants',
}
